export function closeJoyWidget() {
  if (!window.AVADA_JOY || !window.joyInstance) return;
  try {
    window.joyInstance.closeWidget();
  } catch (e) {
    console.log('chatty try close joy widget error', e);
  }
}
